export function pauseVideo(video: HTMLVideoElement): void {
  if (!!video.currentTime && !video.paused && !video.ended) {
    video.pause();
  }
}
